/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import Dialog from "../Dialog";

type IModalHelp = {
    open: boolean;
    onClose: () => void;
    pdfContent: Blob;
};

const ModalHelp = ({ open, onClose, pdfContent }: IModalHelp) => {
    const blob = new Blob([pdfContent], { type: "application/pdf" });
    const blobURL = URL.createObjectURL(blob);

    return (
        <Dialog
            openModal={open}
            onHide={onClose}
            size="width-1000 modal-white modal-radius-8"
        >
            <div style={{ height: "100vh" }}>
                <embed
                    src={`${blobURL}#toolbar=0&navpanes=0`}
                    type="application/pdf"
                    width="100%"
                    height="100%"
                />
            </div>
        </Dialog>
    );
};

export default ModalHelp;
